import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

// material-ui
import { Box, Button, Card, Grid, Typography } from '@mui/material';

import { getPlaces } from 'services/placeServices';

import TableComponent from 'components/TopCourtComponents/Table/TableComponent';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import { getUrlCourtCode } from 'helper/Court';


function Merchants({

}) {
    const [isLoading, setLoading] = useState(true)
    const navigate = useNavigate()
    const [rows, setRows] = useState([])
    const [filter, setFilter] = useState({
        merchant: true
    })

    useEffect(() => {
        setLoading(true)
        loadPlace()
    }, [filter])

    const loadPlace = async () => {
        let { data, error } = await getPlaces({
            queryParams: filter ? filter : ''
        })
        if (error) { console.log(error) }
        if (data) {
            setRows(data)
            setLoading(false)
        }
    }

    const valueCustomator = (row) => {
        return ({
            date: <span className='span-link' onClick={() => {
                navigate(`/${getUrlCourtCode()}/merchants/edit/${row._id}`)
                // window.location.href = `/${getUrlCourtCode()}/merchants/edit/${row._id}`
            }}>{row.name}</span>,
            orderId: <TCLabel>{row.address}</TCLabel>,
        })
    }

    let permissionInfo = JSON.parse(localStorage.getItem("user_info")).merchantInfo || null

    return (
        <>
            {/* <Button variant="contained" sx={{mb:2}} disableElevation onClick={() => {
        // window.location.href = "/courts/add"
        navigate("/courts/add")
      }}>Add New Places</Button> 
      <CourtFilter filter={filter} onChangeFilter={setFilter} /> */}
            {/* <Grid container xs={12}>
                <Grid item xs={3}> */}
            {
                !permissionInfo &&
                <Button variant="contained" sx={{ mb: 2 }} disableElevation onClick={() => {
                    // window.location.href = "/courts/add"
                    navigate(`/${getUrlCourtCode()}/merchants/add`)
                }}>Add New Merchant</Button>
            }
            {/* </Grid> */}
            {/* <Grid item xs>
                    <CourtFilter filter={filter} onChangeFilter={setFilter} />
                </Grid> */}
            {/* </Grid> */}
            <TableComponent
                columns={[
                    { label: "Merchant Name" },
                    { label: "Address" },
                ]}
                rows={rows}
                valueCustomator={valueCustomator}
                loading={isLoading}
            />
        </>
    )
}

export default Merchants;
